import { computed, makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'
import { empty } from '../firestore/SettingsKillSwitch/schema'
import type { FirestoreSettingsKillSwitch } from '../firestore/SettingsKillSwitch/schema'

export class SettingsKillSwitch extends ObservableModelWithDecorators<FirestoreSettingsKillSwitch> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSettingsKillSwitch>
  ) {
    super(repository, doc)

    makeObservable(this)
  }

  @computed
  get isEnabled() {
    return this.data?.enabled ?? false
  }

  @computed
  get reason() {
    return this.data.reason
  }
}
